import React from 'react'

export default function Spacer ({
  height = 1,
  className
}) {
  const _className = [
    'menu-spacer',
    className
  ].filter(name => name)
  .join(' ')

  return (
    <div className={_className} style={{ height }}/>
  )
}